import React from 'react'

const Skeleton = () => {
    return <div style={{ height: '210px', background: '#353D45' }} className="image skeleton"></div>
}

export default Skeleton
